import './App.css';
import Header from './Components/Header/Header';
import SendPushNotification from './Components/SendPushNotification/SendPushNotification';
import { MsalProvider, AuthenticatedTemplate } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

function App(props: { msalInstance: PublicClientApplication }) {
  return (
    <>
      <MsalProvider instance={props.msalInstance}>
        <Header />
        <AuthenticatedTemplate>
          <SendPushNotification />
        </AuthenticatedTemplate>
      </MsalProvider>
    </>
  );
}

export default App;
